<template>
    <mslPage :aIndex="1">
        <template v-slot:mslBody>
            <div class="production">
                <div class="pro_center left_center">
                    <div class="left">
                        <div class="title">产品类别</div>
                        <div class="line"></div>
                        <div class="tabs pointer" :class="{ active: activeIndex == index }" @click="swiperTab(index)"
                             v-for="(item, index) in 6" :key="index">终端直饮机
                        </div>
                    </div>
                    <div class="right">
                        <div class="list flex flex-dir-left flex-wrap">
                            <div class="item" v-for="(item, index) in 5" :key="index">
                                <div class="w">
                                    <div class="i_title w d_ellipsis">热水器末端净水家用除垢器大流量自来水阻垢器</div>
                                    <!--                                        <div class="line leave_line_width_showly hover_line_width_showly"></div>-->
                                    <div class="price">￥1587.00</div>
                                </div>
                                <div class="img_box r_position">
                                    <router-link to="./production_detail" class="td_none">
                                        <div class="mask flex flex-dir-left flex-main-center flex-cross-center a_position l_0 r_0 leave_slowly hover_slowly">
                                            <div class="buy_btn row_center leave_slowly hover_slowly">
                                                立即购买
                                            </div>
                                        </div>
                                    </router-link>
                                    <img src="../assets/pc_pic/pro_sort/pro_1.png" alt="" class="image_2">
                                </div>
                            </div>
                        </div>
                        <div class="page row_center">
                            <el-pagination
                                    :page-size="20"
                                    :pager-count="11"
                                    layout="prev, pager, next"
                                    :total="1000">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </mslPage>
</template>

<script>
    export default {
        name: "production",
        data() {
            return {
                activeIndex: 0,
            }
        },
        watch: {
            activeIndex: {
                handler (val) {

                }
            }
        },
        methods: {
            swiperTab(index) {
                var _index = index;
                this.activeIndex = _index;
            }
        }
    }
</script>

<style scoped lang="scss">

    .production {
        min-width: 1280px;
        .pro_center {
            width: 100%;
            height: 1250px;

            .left {
                width: 30%;
                height: 1250px;
                background-color: #fafafa;
                padding: 48px;
                box-sizing: border-box;

                .title {
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 28px;
                    color: #333333;
                }

                .line {
                    width: 100%;
                    height: 1px;
                    background-color: #8C8C8C;
                    margin: 34px 0;
                }

                .tabs {
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                    color: #333333;
                    opacity: 0.8;
                    margin-top: 32px;

                    &:first-child {
                        margin-top: 0;
                    }
                }

                .active {
                    font-weight: bold !important;
                }
            }

            .right {
                width: 70%;
                height: 1250px;
                padding: 80px;
                box-sizing: border-box;

                .item {
                    width: 32%;
                    margin-right: 2%;
                    margin-bottom: 48px;

                    &:nth-child(3n) {
                        margin-right: 0;
                    }

                    /*&:nth-last-child(1), &:nth-last-child(2), &:nth-last-child(3), {*/
                    /*    margin-bottom: 0;*/
                    /*}*/

                    .i_title {
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 24px;
                        color: #262626;
                    }

                    .mask {
                        width: 100%;
                        height: 100%;
                        z-index: 10;
                        padding: 32px;
                        box-sizing: border-box;

                        .buy_btn {
                            width: 200px;
                            height: 48px;
                            border-radius: 6px;
                            border: 1px solid #262626;
                            color: #262626;
                            font-size: 18px;
                            font-weight: 500;
                            display: none;
                        }
                    }

                    .line {
                        margin-top: 12px;
                        width: 40px;
                        height: 1px;
                        background-color: #262626;
                    }

                    .price {
                        margin-top: 12px;
                        font-size: 16px;
                        font-weight: bold;
                        line-height: 28px;
                        color: #262626;
                    }

                    .img_box {
                        margin-top: 32px;
                        width: 100%;
                        height: 370px;
                        overflow: hidden;
                        object-fit: contain;
                        &:hover {
                            .mask {
                                background-color: rgba(255, 255, 255, .8);

                                .buy_btn {
                                    display: flex;

                                    &:hover {
                                        background-color: #262626;
                                        color: #fff;
                                    }
                                }
                            }
                            .image_2 {
                                object-fit: contain;
                                transform: scale(1.05);
                                transition: all 0.6s;
                            }
                        }
                        .image_2 {
                            width: 100%;
                            height: 100%;
                            transition: all 0.6s;
                            object-fit: contain;
                        }
                    }
                }

                .page {
                    padding: 48px 0;
                }
            }
        }
    }
</style>
